import { ApiKeyItemModel } from '@/services/apis/setting/module'
import openApiBaseApi from './base'

class openApi extends openApiBaseApi {
  /**
   * 获取webhook的配置信息
   */
  getWebHookInfo() {
    return this.post<{
      webhookUrl: string
      webhookPubKey: string
      webhookPlatformPubKey: string
      operationStatus: 0 | 3 | 4
    }>('/webhook/info', {})
  }

  /**
   * 创建webhook回调
   * @param webhookUrl
   * @param webhookPubKey
   */
  createWebHook(webhookUrl: string, webhookPubKey: string) {
    return this.post<boolean>('/webhook/create', { webhookUrl, webhookPubKey })
  }

  /**
   * 创建webhook回调
   * @param webhookUrl
   * @param webhookPubKey
   */
  updateWebHook(webhookUrl: string, webhookPubKey: string) {
    return this.post<boolean>('/webhook/update', { webhookUrl, webhookPubKey })
  }

  deleteWebHook() {
    return this.post('/webhook/delete', {})
  }

  /**
   * 获取api列表
   */
  getApiKeyList() {
    return this.get<ApiKeyItemModel[]>('/apiAuthority/list')
  }

  getApiCoSigner() {
    return this.post<ApiKeyItemModel[]>('/apiAuthority/getCoSignerList')
  }

  /**
   * 创建api key
   * @param params
   */
  createApiKey(params: ApiKeyRequestParams) {
    return this.post('/apiAuthority/create', params)
  }

  /**
   * 删除api key
   * @param userKey
   */
  deleteApiKey(userKey: string, gaCode = 1) {
    return this.post('/apiAuthority/delete', { userKey, gaCode })
  }

  /**
   * 允许api key
   * @param userKey
   * @param gaCode
   */
  enableApiKey(userKey: string, gaCode: string) {
    return this.post('/apiAuthority/enable', { userKey, gaCode })
  }

  /**
   * 禁止 api key
   * @param userKey
   * @param gaCode
   */
  disableApiKey(userKey: string, gaCode: string) {
    return this.post('/apiAuthority/disable', { userKey, gaCode })
  }

  /**
   * 修改 api key
   * @param userKey
   * @param ipAddrList
   */
  updateApiKey(userKey: string, ipAddrList: string[], permissionModeKeys: string[], gaCode = 1) {
    return this.post('/apiAuthority/update', { userKey, ipAddrList, permissionModeKeys, gaCode })
  }

  /**
   * 显示脱敏信息
   */
  showPlainText(userKey: string, gaCode = 1) {
    return this.post('/apiAuthority/show', { userKey, gaCode })
  }
}
export interface ApiKeyRequestParams {
  userKey?: string
  apiName: string
  apiPubKey: string
  permissionModeKeys: string[]
  ipAddrList: string[]
  ips?: string
}

// 显示脱敏数据的类型
export enum ApiKeyShowTypeEnum {
  API_KEY = 1,
  USER_PUB_KEY = 2,
  PLATFORM_PUB_KEY = 3,
}
export default new openApi()
